import { useThemeStore } from "@stores/theme.store";
import { Button, Select } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { LuBookOpen, LuChevronRight, LuInbox } from "react-icons/lu";
import { Spiner } from "@components/loaders/spiner";
import { StudentTahfidz } from "@services/dtos/school.dto";
import { FilterOutlined } from "@ant-design/icons";
import { PopupCustom } from "@components/general/popup";

moment.locale("id");

export const TahfidzDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_TAHFIDZ, nis, limit],
    queryFn: () => SchoolService.studentTahfidz({ nis, limit }),
  });

  const onOpenDetail = (tahfidz: StudentTahfidz) => {
    navigate(linkPage.TAHFIDZ_DETAIL_PAGE, { state: tahfidz });
  };

  useEffect(() => {
    setAppBar({ title: "Tahfidz", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Tahfidz",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        {/* filter bar */}
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
          <div className="tw-text-sm tw-text-white/80">
            Menampilkan{" "}
            <span className="tw-font-semibold tw-text-white">
              {limit} data terakhir
            </span>
          </div>
          <FilterOutlined
            className="tw-p-2 tw-text-xl tw-bg-transparent card-body"
            onClick={() => setPopupFilter(true)}
          />
        </div>

        {/* list */}
        {isPending ? (
          <div className="tw-text-center card-body">
            <Spiner />
          </div>
        ) : data?.data != null && data.data.length > 0 ? (
          <div className="tw-space-y-3">
            {data.data.map((item, idx) => (
              <div
                key={idx}
                className="card-body tw-flex tw-items-center tw-gap-3 tw-cursor-pointer"
                onClick={() => onOpenDetail(item)}
              >
                <div
                  className="tw-flex tw-items-center tw-justify-center tw-rounded-2xl tw-w-10 tw-h-10 tw-shrink-0"
                  style={{ background: "#e0f9f2" }}
                >
                  <LuBookOpen className="tw-text-lg tw-text-[#0d9488]" />
                </div>
                <div className="tw-flex-1 tw-min-w-0">
                  <div className="tw-text-sm tw-font-semibold tw-text-text-primary tw-truncate">
                    {item.tambahan || "-"} halaman
                  </div>
                  <div className="tw-text-xs tw-text-text-secondary tw-mt-0.5">
                    {moment(item.tanggal ?? Date.now()).format("DD MMM YYYY")}
                  </div>
                </div>
                <div className="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
                  {item.nilai ? (
                    <span
                      className="tw-text-[10px] tw-font-bold tw-px-2 tw-py-0.5 tw-rounded-full"
                      style={{
                        background: "#e0f9f2",
                        color: "#0d9488",
                        border: "1px solid #99f6e4",
                      }}
                    >
                      {item.nilai}
                    </span>
                  ) : null}
                  <LuChevronRight className="tw-text-base tw-text-text-secondary" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="tw-p-8 tw-text-center card-body">
            <LuInbox className="tw-mx-auto tw-mb-2 tw-text-5xl tw-text-text-secondary tw-opacity-40" />
            <div className="tw-text-sm tw-text-text-secondary">
              Data tidak ditemukan
            </div>
          </div>
        )}
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <Select
          className="tw-text-base"
          placeholder="Pilih Jumlah Ditampilkan"
          defaultValue={limit}
          style={{ width: "100%" }}
          allowClear
          onChange={(e) => setLimit(e)}
          options={[
            { value: "5", label: "5 data terakhir" },
            { value: "10", label: "10 data terakhir" },
            { value: "25", label: "25 data terakhir" },
          ]}
        />
        <Button
          onClick={() => setPopupFilter(false)}
          className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
        >
          Tutup
        </Button>
      </PopupCustom>
    </>
  );
};
